import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
// Components
import Caret from './shared/icons/Caret';
import BBCode from './shared/richText/BBCode';
import LikeIcon from './shared/icons/Like';

// Styles
import { colorPalette, textStyles } from '@/styles/styleGuide';
import { darken } from '@/styles/utils';

// Types

// Analytics
import { performApiRequest } from '@/redux/apiData';
var LIKED = 'liked';
var DISLIKED = 'disliked';
var FAQ_ITEM = 'FAQ';
var mapStateToProps = function mapStateToProps(_state, _props) {
  return {};
};
var ExpandableListBlock = /*#__PURE__*/function (_React$Component) {
  function ExpandableListBlock() {
    var _this;
    _classCallCheck(this, ExpandableListBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ExpandableListBlock, [].concat(args));
    _defineProperty(_this, "refObject", {});
    _defineProperty(_this, "state", {
      listOpen: {},
      buttonFeedback: {}
    });
    _defineProperty(_this, "toUpperCase", function (title) {
      return title.toUpperCase();
    });
    // Used to give feedback to FAQ item
    _defineProperty(_this, "handleFeedbackClick", function (index, id, feedbackType) {
      var dispatch = _this.props.dispatch;
      dispatch(performApiRequest('postFAQFeedback', {}, {
        id: id,
        action: feedbackType === LIKED ? LIKED : DISLIKED
      }));
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          buttonFeedback: _defineProperty({}, index, {
            clicked: feedbackType === LIKED ? LIKED : DISLIKED
          })
        });
      });
    });
    _defineProperty(_this, "toggleList", function (index, id, title) {
      // If listitem is not open and title is equal to FAQ, send tracker
      var dispatch = _this.props.dispatch;
      var projectName = _this.props.match ? _this.props.match.params.projectSlug : '';
      if ((!_this.state.listOpen[index] || _this.state.listOpen[index] && !_this.state.listOpen[index].expanded) && _this.toUpperCase(_this.props.list.title) === FAQ_ITEM) {
        dispatch(performApiRequest('postOpenFaq', {}, {
          id: id,
          action: 'open'
        }));
      }
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          listOpen: _defineProperty({}, index, {
            expanded: !_this.state.listOpen[index] ? true : !_this.state.listOpen[index].expanded,
            height: _this.refObject[index].clientHeight
          })
        });
      });
    });
    return _this;
  }
  _inherits(ExpandableListBlock, _React$Component);
  return _createClass(ExpandableListBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        list = _this$props.list,
        title = _this$props.title,
        description = _this$props.description;
      var _this$state = this.state,
        listOpen = _this$state.listOpen,
        buttonFeedback = _this$state.buttonFeedback;
      return __jsx(Container, {
        "data-id": "components_ExpandableListBlock_Container"
      }, title && __jsx(ListTitle, {
        "data-id": "components_ExpandableListBlock_ListTitle"
      }, title), description && __jsx(BBCode, {
        content: description,
        "data-id": "components_ExpandableListBlock_BBCode"
      }), list && (list.items || []).map(function (item, index) {
        return __jsx(ListContainer, {
          key: index,
          "data-id": "components_ExpandableListBlock_ListContainer"
        }, __jsx(TitleContainer, {
          onClick: function onClick() {
            return _this2.toggleList(index, item.id, item.title);
          },
          "data-id": "components_ExpandableListBlock_TitleContainer"
        }, __jsx(Caret, {
          direction: listOpen[index] && listOpen[index].expanded ? 'down' : 'right',
          "data-id": "components_ExpandableListBlock_Caret"
        }), __jsx(Title, {
          "data-id": "components_ExpandableListBlock_Title"
        }, item.title)), __jsx(ContentContainer, {
          height: listOpen[index] && listOpen[index].expanded ? listOpen[index].height : 0,
          expanded: listOpen[index] && listOpen[index].expanded,
          "data-id": "components_ExpandableListBlock_ContentContainer"
        }, __jsx(InnerContent, {
          ref: function ref(el) {
            _this2.refObject[index] = el;
          },
          "data-id": "components_ExpandableListBlock_InnerContent"
        }, __jsx(BBCode, {
          content: item.content,
          "data-id": "components_ExpandableListBlock_BBCode"
        }), list.title && list.title.toUpperCase() === FAQ_ITEM && __jsx(FeedbackContainer, {
          "data-id": "components_ExpandableListBlock_FeedbackContainer"
        }, __jsx("span", {
          "data-id": "components_ExpandableListBlock_span"
        }, "Was dit antwoord nuttig?"), __jsx(Button, {
          type: LIKED,
          onClick: function onClick() {
            return _this2.handleFeedbackClick(index, item.id, LIKED);
          },
          clicked: buttonFeedback[index] && buttonFeedback[index].clicked === LIKED ? LIKED : false,
          "data-id": "components_ExpandableListBlock_Button"
        }, __jsx(LikeIcon, {
          "data-id": "components_ExpandableListBlock_LikeIcon"
        })), __jsx(Button, {
          type: DISLIKED,
          onClick: function onClick() {
            return _this2.handleFeedbackClick(index, item.id, DISLIKED);
          },
          clicked: buttonFeedback[index] && buttonFeedback[index].clicked === DISLIKED ? DISLIKED : false,
          "data-id": "components_ExpandableListBlock_Button"
        }, __jsx(LikeIcon, {
          "data-id": "components_ExpandableListBlock_LikeIcon"
        }))))));
      }));
    }
  }]);
}(React.Component);
export default withMatch(connect(mapStateToProps)(ExpandableListBlock));
var ListTitle = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 5rem;\n  margin-bottom: 10rem;\n"])), textStyles.title, colorPalette.headerGrey);
var Container = styled.section(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 30rem auto 40rem;\n  max-width: 1020rem;\n"])));
var ListContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow: hidden;\n  border-bottom: 1rem solid ", ";\n"])), colorPalette.lightGrey);
var TitleContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  > svg {\n    flex-shrink: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n"])));
var Title = styled.h3(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-left: 20rem;\n"])), textStyles.subTitle, colorPalette.blue);
var ContentContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n  transition: all 0.3s ease-in-out;\n  max-height: ", "px;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? '20' : '0';
}, function (props) {
  return props.height;
});
var InnerContent = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0;\n"])), textStyles.bodyText, colorPalette.textGrey);
var FeedbackContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 15rem;\n\n  > span {\n    padding-right: 20rem;\n  }\n"])));
var Button = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 30rem;\n  height: 30rem;\n  background-color: ", ";\n  transition: background-color 0.3s ease-in-out;\n  border-radius: 50%;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 6rem;\n\n  > svg {\n    transition: transform 0.1s ease-in-out;\n    transform: scale(0.5);\n    position: relative;\n    transform-origin: center center;\n    will-change: transform;\n  }\n\n  ", ";\n"])), function (props) {
  return props.clicked ? props.clicked === LIKED ? darken(colorPalette.darkGreen, 10) : darken(colorPalette.darkOrange, 10) : colorPalette.lightBeige;
}, function (props) {
  return props.type === LIKED ? "\n\n    &:hover {\n      background-color: ".concat(colorPalette.darkGreen, ";\n\n      > svg {\n        transform: scale(0.6)\n      }\n    }\n\n    &:active {\n      background-color: ").concat(darken(colorPalette.darkGreen, 10), ";\n    }\n\n  ") : "\n    > svg {\n     transform: scale(0.5) rotate(180deg);\n     top: 1rem;\n    }\n\n    &:hover {\n      background-color: ".concat(colorPalette.darkOrange, ";\n\n      > svg {\n        transform: scale(0.6) rotate(180deg);\n      }\n    }\n\n    &:active {\n      background-color: ").concat(darken(colorPalette.darkOrange, 10), ";\n    }\n  ");
});